<template>
  <div class="gameView" v-show="match">
    <span v-if="match.board" class="tag is-info is-small mb-1">
      Board {{ match.board }}
    </span>

    <div>
      <div class="gameView__player mb-2">
        <ProfileCard :player="match.player2" />
        <div>
          <TimerDisplay
            :duration="blackTimeLeft"
            :run="turnColor === 'black'"
          />
          <GameResult
            v-show="match.player_2_score != null"
            :result="match.result"
            :score="match.player_2_score"
          />
        </div>
      </div>

      <div class="gameView__board">
        <PvPChessboard :pgn="currentPgn" :showThreats="showThreats" />
      </div>

      <div class="gameView__player">
        <ProfileCard :player="match.player1" />
        <div>
          <TimerDisplay
            :duration="whiteTimeLeft"
            :run="turnColor === 'white'"
          />
          <GameResult
            v-show="match.player_1_score != null"
            :result="match.result"
            :score="match.player_1_score"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PvPChessboard from "@/components/variants/PvPChessboard.vue";
import ProfileCard from "@/components/players/ProfileCard.vue";
import GameRenderless from "./GameRenderless.js";
import TimerDisplay from "@/components/TimerDisplay.vue";
import GameResult from "@/components/games/GameResult.vue";

export default {
  name: "gameView",

  props: ["gameId", "showThreats"],

  components: {
    PvPChessboard,
    ProfileCard,
    TimerDisplay,
    GameResult,
  },

  extends: GameRenderless,

  methods: {
    // Override the default method. We only want firebase data for gameView
    async getMatchFromSql(gameId) {
      return gameId;
    },
  },

  created() {
    this.matchId = this.gameId;
  },
};
</script>

<style scoped>
.gameView__player {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 52px;
}
</style>
